var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 17.3332C4.39697 17.3332 0.666016 13.6022 0.666016 8.99984C0.666016 4.39746 4.39697 0.666504 8.99935 0.666504C13.6017 0.666504 17.3327 4.39746 17.3327 8.99984C17.3327 13.6022 13.6017 17.3332 8.99935 17.3332ZM8.16818 12.3332L14.0608 6.44061L12.8823 5.2621L8.16818 9.97617L5.81119 7.61909L4.63267 8.79767L8.16818 12.3332Z",
    fill: "#02AB75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircleFill);
export default __webpack_public_path__ + "static/media/checkbox-circle-fill.c3eac19f5b383cb5921f4828118c7d82.svg";
export { ForwardRef as ReactComponent };